import { Fragment, useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { API_BASE_URL } from "../baseURL";
import AddMultiplicatorModal from "./addMultiplicatorModal";
import Multiplicator from "./Multiplicator";
import EditMultiplicatorModal from "./editMultiplicatorModal";

const MultiplicatorsTable = () => {
    const [multiplicators, setMultiplicators] = useState(null);

    const [showEditMultiplicatorModal, setShowEditMultiplicatorModal] = useState(false);
    const [showAddMultiplicatorModal, setShowAddMultiplicatorModal] = useState(false);
    const [multiplicator, setMultiplicator] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);

    useEffect(() => {
        if (!multiplicators) {
            fetch(`${API_BASE_URL}/multiplicators`, {
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem('token')
                },
                method: "GET"
            })
                .then((response) => response.json())
                .then((data) => setMultiplicators(data));
        }
    }, []);


    const handleKeyPress = () => {
        multiplicators.forEach(multiplicator => multiplicator.isHidden = false);

        let inputVal = document.getElementById("search").value;

        const filteredData = multiplicators.map(multiplicator => {
            if(!multiplicator.surname.toLowerCase().includes(inputVal.toLowerCase())) {
                multiplicator.isHidden = true;
            }
            return multiplicator;
        })

        setMultiplicators(filteredData);
    };

    function cleanInput() {
        document.getElementById("search").value = "";

        const filteredData = multiplicators.map(multiplicator => {
                multiplicator.isHidden = false
                return multiplicator;
            }
        )

        setMultiplicators(filteredData);
    }

    function deleteMultiplicator(multiplicatorId) {
        fetch(`${API_BASE_URL}/multiplicators/${parseInt(multiplicatorId)}/delete`, {
            method: "DELETE",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
        }).then((response) => response.json())
            .then((data) => setMultiplicators(data));
    }

    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };

    return (
        <>
            { multiplicators ? (
                <div style={{margin: "20px 20px 20px 20px"}}>
                    <IconButton style={{float: "right"}}>
                        <Add fontSize="inherit" className="custom-btn-add" onClick={() => {
                            setShowAddMultiplicatorModal(true);
                            // setFarmer(23);
                        }} />
                    </IconButton>

                    <input
                        type="text"
                        placeholder="Nachname..."
                        id="search"
                        className="mb-4 p-2 border border-gray-300 rounded"
                        onKeyUp={handleKeyPress}
                    />

                    <IconButton >
                        <DeleteForeverIcon style={{color: "red", fontSize: "40px"}} onClick={ cleanInput }></DeleteForeverIcon>
                    </IconButton>

                    <table>
                        <thead>
                            <tr>
                                <th style={{ paddingLeft: "20px"}}> Nr. </th>
                                <th> Nachname </th>
                                <th> Vorname </th>
                                <th> Unternehmen </th>
                                <th> Kommentar </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                multiplicators.map((multiplicator, index) => multiplicator.isHidden ? null :(
                                    <>
                                        <tr>
                                            <td style={{ paddingLeft: "20px"}}>{index + 1}.</td>
                                            <td
                                                onClick={()=> toggleRow(multiplicator.id) }
                                                style={{ cursor: "pointer", color: "blue" }}>
                                                { expandedRow === multiplicator.id ? "▼" : "▶" } { multiplicator.surname }
                                            </td>
                                            <td>{multiplicator.firstName}</td>
                                            <td>{multiplicator.firm}</td>
                                            <td>{multiplicator.comment}</td>

                                            <td className="actions">
                                                <IconButton>
                                                    <Edit className="custom-btn-edit"
                                                          onClick={() => {
                                                              setShowEditMultiplicatorModal(true);
                                                              setMultiplicator(multiplicator);
                                                          }} />
                                                </IconButton>
                                                <IconButton>
                                                    <DeleteIcon className="custom-btn-delete" data-confirm="Are you sure to delete this item?"
                                                                onClick={() => {  if(window.confirm("Wirklich entfernen?")) {
                                                                    deleteMultiplicator(multiplicator.id);
                                                                }}} />
                                                </IconButton>
                                            </td>
                                        </tr>

                                        { expandedRow === multiplicator.id && (
                                            <tr>
                                                <td colSpan={13}>
                                                    <Multiplicator multiplicator={multiplicator} setMultiplicator={setMultiplicator} />
                                                </td>
                                            </tr>
                                        ) }
                                    </>
                                ))
                            }

                            { showEditMultiplicatorModal ? (
                                <EditMultiplicatorModal multiplicator={multiplicator} setMultiplicators={setMultiplicators} setShowEditMultiplicatorModal={setShowEditMultiplicatorModal} />
                            ) : null }

                            { showAddMultiplicatorModal ? (
                                <AddMultiplicatorModal setMultiplicators={setMultiplicators} setShowAddMultiplicatorModal={setShowAddMultiplicatorModal} />
                            ) : null }
                        </tbody>
                    </table>
                </div>
            ): null }
        </>
    )
}

export default MultiplicatorsTable;
